const WordleCopilot = () => {
    return (
        <div style={{ maxWidth: '350px', margin: '0 auto' }}>
            <iframe src="https://wordlecopilot.com#wordlecopilot" width="350" height="650" />
        </div>
    );
};

export default WordleCopilot;